import { UpdateTicket } from './../ticketview/updateticket';
import { Module } from './../module/module';
import { Component, OnInit, Input, Pipe, PipeTransform, ViewChild, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { User } from '../user/user';
import { UserService } from '../_services';
import { ClientService } from '../client/clientservice';
import { Machine } from '../machine/machine';
import { Client } from '../client/client';



@Component({
  selector: 'app-clientview',
  templateUrl: './clientview.component.html',
  styleUrls: ['../app.component.less', './clientview.component.less']
})
export class ClientviewComponent implements OnInit {

  isLoading = true;
  _currentUser: User;
  machines: Machine[];
  _currentClient: Client;
  editable : boolean = true; 
  
  constructor(private userservice: UserService,
    private http: HttpClient,
    private route: ActivatedRoute,
    private clientservice: ClientService

  ) { }

  // PAGE LOAD
  ngOnInit(): void {
    this._currentUser = this.userservice.getCurrentUserFromCookie();
    const id = +this.route.snapshot.paramMap.get('id');
    this.clientservice.getClientsLightById(id).subscribe(result => {
      console.log(result);
      this._currentClient = result;
      this.machines = this._currentClient.machines;
      this.isLoading = false;
    });
  }

toggle()
{
  this.editable = !this.editable; 
}
update()
{
  try
  {
    
this.clientservice.update(this._currentClient).subscribe();
this.toggle();
  }
  catch
  {

  }
}


}
